<template>
  <div id="corporate-setting">
    <page-layout-template />
  </div>
</template>

<script>
import PageLayoutTemplate from "./PageLayoutTemplate.vue";

export default {
  components: {
    PageLayoutTemplate,
  },
  data() {
    return {
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style lang="scss">
#corporate-setting {
}
</style>
